export enum CompliancePageNames {
  PRODUCT = "Product Fees",
  COUNTRY = "By Country",
  STREAM = "by Stream",
  SCHEME = "by Scheme",
  OVERVIEW = "Overview"
}

export enum StreamPageNames {
  WEEE = "by Stream - WEEE",
  BATT = "by Stream - Battery",
  PACK = "by Stream - Packaging",
  SUP = "by Stream - SUP (Single Use Plastic)",
  TEXTILES = "by Stream - Textiles",
  PAPER = "by Stream - Paper (Non-Packaging)"
}
